import React, { Component } from "react";

export default class ReportsNav extends Component {
  render() {
    return (
      <div className="search-nav">
        <div className="container-fluid">
          <div className="search-title">
            <h4>Reports</h4>
          </div>
        </div>
      </div>
    );
  }
}
